import { React, useRef, useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AlertDialog from '../Modals/AlertDialog'
import ErrorIcon from '@mui/icons-material/Error';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import StyledRadio from '../StyledExtensions/StyledRadio'
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import Slider from '@mui/material/Slider';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RemoveIcon from '@mui/icons-material/Remove';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

export default function TipPrompt(props) {

    const [tipAmount, setTipAmount] = useState(props.pickupRequest.TipAmount !== undefined ?
        parseFloat(props.pickupRequest.TipAmount) : 0);
    const [isCustomAmount, setIsCustomAmount] = useState(false);
    const [tipAmountCustomText, setTipAmountCustomText] = useState('');
    const [tipAmountCustom, setTipAmountCustom] = useState(0);
    function onAccept() {
        // validate

        let isValid = true;

        if (isValid) {
            if (isCustomAmount) {
                props.onAccept(tipAmountCustom);
            }
            else {
                props.onAccept(tipAmount);
            }
        }
    }

    const init = useEffect(function () {
        console.log('TipPrompt init');
        if (tipAmount > 0 &&
            tipAmount != 1 &&
            tipAmount != 3 &&
            tipAmount != 5 &&
            tipAmount != props.paymentToCustomer) {
            setIsCustomAmount(true);
            setTipAmount(tipAmount);
            setTipAmountCustomText(tipAmount);
            setTipAmountCustom(tipAmount);
        }
    }, []);

    function handleTipOptionClicked(tipAmount) {
        setTipAmount(tipAmount);
        setIsCustomAmount(false);
    }

    function handleCustomTipClicked() {
        setIsCustomAmount(!isCustomAmount);
        setTipAmount(0);
    }

    function handleCustomKeypress(val) {
        let isValid = false;
        if (val.trim() == '') {
            setTipAmountCustomText('');
            setTipAmountCustom(0);
            isValid = true;
        }
        else if (!isNaN(val)) {
            try {
                let newVal = parseFloat(val);

                let payment = 0.0;
                if (props.paymentToCustomer !== undefined) {
                    if (props.paymentToCustomer !== '') {
                        payment = parseFloat(props.paymentToCustomer.replace('$', ''));
                    }
                }

                if (newVal < 0) {
                    newVal *= -1;
                }

                if (newVal <= payment) {
                    if (countDecimals(newVal) <= 2) {
                        isValid = true;
                        setTipAmountCustomText(val);
                        setTipAmountCustom(newVal);
                    }


                }
            }
            catch {

            }
        }
        else {
            if (val.trim() == '') {
                setTipAmountCustomText('');
                setTipAmountCustom(0);
            }
        }

        
    }

    function formatMoney(val) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',

            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });


        return formatter.format(val); /* $2,500.00 */

    }

    function countDecimals(value) {
        if (value.toString().indexOf('.') < 0) return 0;
        //if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    }

    let payment = 0.0;
    if (props.paymentToCustomer !== undefined) {
        if (props.paymentToCustomer !== '') {
            payment = parseFloat(props.paymentToCustomer.replace('$', ''));
        }
    }
    return (<div>
        <Dialog
            open={true}
            maxWidth="330px"

            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"  
        >
            <DialogContent style={{ width: '330px' }}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    backgroundColor: 'var(--sipzee-gray-3)',
                    
                }}>
                    <img src='/images/BottleBlack.png' style={{height:'35px', margin:'5px'} } />
                    <div style={{alignSelf:'center', marginRight:'5px'} }>Bottle Tip</div>
                    <div></div>
                </div>
                <div>
                    No need to tip using cash. You can tip using your bottles & cans.
                </div>

                <div style={{ marginTop: '10px', fontWeight:'bold' }}>
                    Amount before tip: {props.paymentToCustomer }
                </div>

                <div style={{ display: 'flex', flexDirection:'column'}}>
                    <FormControlLabel control={<StyledRadio checked={tipAmount === 0} onChange={(e) => handleTipOptionClicked(0)} />} label={<span>None</span>} />

                    {payment < 1 ? null :
                        <FormControlLabel control={<StyledRadio checked={tipAmount === 1} onChange={(e) => handleTipOptionClicked(1)} />} label={<span>$1 (10 cans)</span>} />
                    }

                    {payment < 3 ? null :
                        <FormControlLabel control={<StyledRadio checked={tipAmount === 3} onChange={(e) => handleTipOptionClicked(3)} />} label={<span>$3 (30 cans)</span>} />
                    }

                    {payment < 5 ? null :
                        <FormControlLabel control={<StyledRadio checked={tipAmount === 5} onChange={(e) => handleTipOptionClicked(5)} />} label={<span>$5 (50 cans)</span>} />
                    }

                    <FormControlLabel control={<StyledRadio checked={tipAmount === payment} onChange={(e) => handleTipOptionClicked(payment)} />} label={<span>All cans</span>} />

                    <FormControlLabel control={<StyledRadio checked={isCustomAmount} onChange={(e) => handleCustomTipClicked()} />} label={<span>Custom</span>} />

                    <div>
                        {(!isCustomAmount ? null :
                            <TextField value={tipAmountCustomText} onChange={(e) => handleCustomKeypress(e.target.value)}
                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]+([\.,][0-9]+)?', step: '0.01' }} />
                        )}
                    </div>
                </div>

                <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                    Amount after tip: {formatMoney(payment - (isCustomAmount ? tipAmountCustom : tipAmount))}
                </div>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'flex-start' }}>
                <Button variant='outlined' onClick={props.onClose}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={onAccept} style={{ marginLeft: 'auto', backgroundColor: 'var(--sipzee-green)' }}>
                    Add Tip
                </Button>
            </DialogActions>
        </Dialog>
    </div>);
}